import Bookmark from '@/types/Bookmark';
import { TranslateResult } from 'vue-i18n';
import { Vue, Component } from 'vue-property-decorator';


/** Classe utilitaire de manipulation features désigné dans les marque-pages */
@Component
export class BookmarkUtils extends Vue {
    /**
     * Récupère l'icône de la fonctionnalité root du path stocké dans le bookmark
     * @param bookmark Bookmark cible
     */
    protected getRootIconFromBookmark(bookmark: Bookmark): string {
        // On décompose le "path"
        let split : string[] = bookmark.Feature.split(' / ');
        // Si le "path" est valide alors on traite
        if(split.length > 0) {
            // On récupère le path de la fonctionalitée racine de "level 1"
            let rootPath = split[0];
            return this.$store.getters['GetFeature'](rootPath).Icon;
        }
        return "";
    }

	/**
     * Contruit une liste d'objet dédié à la réalisation d'un affichage de path 100% personalisé
     * @remark à améliorer au besoin
     * @param bookmark "bookmark" cible
     * @param delimiter Délimiteur de remplacement (origine ' / ').
     */
    protected getTranslateDescriptionPath(bookmark: Bookmark, delimiter: string): TranslatePathDescription[] {
        let split: string[] = bookmark.Feature.split(' / ');
        let level: number = 0;
        let result: TranslatePathDescription[] = [];
        if (split.length > 0) {
            split.forEach(element => {
                level++;
                let item :TranslatePathDescription = { 
                    Level: level, 
                    IsDelimiter: false,
                    TranslateContent : this.$t(element),
                    IsFirst: level === 1,
                    IsLast: level === split.length
                }
                result.push(item);
                if(delimiter && level !== split.length) {
                    let itemDelimiteur: TranslatePathDescription = { 
                        Level : level, 
                        IsDelimiter : true,
                        TranslateContent : this.$t(delimiter),
                        IsFirst : false,
                        IsLast : false
                    }
                    result.push(itemDelimiteur);
                }
            });
            return result;
        } 
        return [];
    }

    /**
     * Effectue une traduction sur le path
     * @param path Path complet
     */
    protected getTranslatePath(path: string): string
    {
        // On décompose le path
        let split : string[] = path.split(' / ');

        // Si le "path" est valide alors on traduit avec ajout de ">" à la place de "/"
        if(split.length > 0) {
            let result : string = "";
            split.slice(0, -1).forEach(element => {
                result += this.$t(element) + " > ";
            });
            return result + this.$t(split.at(-1));
        }
        else
            return "";
    }
}

type TranslatePathDescription = {
    Level: number , 
    IsDelimiter: boolean , 
    TranslateContent: TranslateResult , 
    IsFirst: boolean, 
    IsLast: boolean 
};